"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModernaBrand = void 0;
exports.ModernaBrand = {
    "color-brand-50": "#F1F9FE",
    "color-brand-100": "#E2F2FC",
    "color-brand-200": "#BFE6F6",
    "color-brand-300": "#86D2F3",
    "color-brand-400": "#62CDF8",
    "color-brand-500": "#2AACE2",
    "color-brand-600": "#1880B9",
    "color-brand-700": "#0E6896",
    "color-brand-800": "#10587C",
    "color-brand-900": "#134967",
    "color-brand-950": "#01283C"
};
//# sourceMappingURL=ModernaBrand.js.map